module.exports = __webpack_public_path__ + "media/images/favicon-053235f7cf4f74037ce2680cb216cad1.ico";